import React from 'react';
import { Box, Typography } from '@mui/material';
import { MAP_CONFIDENCE_INFO } from '../ExceptionReporting/constants/mapConfidenceConstants';

const MapConfidenceTooltipContent = () => (
  <Box sx={{ maxWidth: 320 }}>
    <Typography variant="caption" fontWeight="bold" display="block" sx={{ mb: 1, textAlign: 'center' }}>
      MAP CONFIDENCE
    </Typography>

    {MAP_CONFIDENCE_INFO?.map(({ val, text }) => (
      <Typography key={val} variant="caption" display="block" sx={{ mb: 0.75 }}>
        <strong>{val} </strong> {text}
      </Typography>
    ))}
  </Box>
);

export default MapConfidenceTooltipContent;
